<template>
  <div class="vaccine-form">
    <div :style="bluebg" class="vaccine-form-bg">
      <div style="width: 100%">新冠疫苗预约</div>
    </div>
    <div class="vaccine-form-content">
      <van-field
        v-model="username"
        colon="true"
        label="姓名"
        placeholder="请输入您的姓名"
      />
      <van-field
        v-model="idCard"
        colon="true"
        label="身份证"
        placeholder="请输入您的身份证号"
      />
      <van-field
        v-model="appointmentdate"
        @click="showPicker = true"
        colon="true"
        readonly
        clickable
        name="area"
        label="预约日期"
        placeholder="请选择日期"
      />
      <van-field
        v-model="appointmenttime"
        readonly
        colon="true"
        label="预约时间"
        placeholder=""
      >
        <div
          slot="input"
          style="
            display: flex;
            justify-content: space-between;
            font-size: 0.88rem;
          "
        >
          <div
            :class="
              chooies === '0'
                ? 'vaccine-form-content-chooies'
                : 'vaccine-form-content-unchooies'
            "
            @click="chooiesclick('0')"
            style="margin: auto"
          >
            上午|{{ aleft }}
          </div>
          <div
            :class="
              chooies === '1'
                ? 'vaccine-form-content-chooies'
                : 'vaccine-form-content-unchooies'
            "
            @click="chooiesclick('1')"
            style="margin: 0 0.4rem"
          >
            下午|{{ pleft }}
          </div>
        </div>
      </van-field>
      <van-field
        v-model="temperature"
        type="number"
        colon="true"
        label="体温"
        placeholder="请输入您的体温"
      />
      <van-field
        v-model="telphone"
        :rules="[{ required: true, message: '请填写正确的手机号' }]"
        colon="true"
        label="手机号"
        placeholder="请输入手机号"
      />
    </div>
    <div class="vaccine-form-content-agreement">
      温馨提示：<br />
      <span
        >1、每个身份证号只可以取消预约一次<br />2、每个身份证号预约成功后必须满21天后才可再次预约<br />3、每个身份证号最多只可以预约2次</span
      >
    </div>
    <div @click="appointmentClick()" class="vaccine-form-content-btn">
      确认预约
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        :columns="dateList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bluebg: {
        backgroundImage: `url(${require("@assets/vaccine_form_bluebg.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto",
      },
      username: "",
      idCard: "",
      appointmentdate: "",
      appointmenttime: "",
      temperature: "",
      telphone: "",
      dateList: [],
      showPicker: false,
      chooies: "",
      aleft: "",
      pleft: "",
      openid: "",
    };
  },
  created() {
    this.openid = this.$route.query.openid;
    this.getDate();
  },
  methods: {
    onConfirm(value, index) {
      this.appointmentdate = value;
      this.getleft(value);
      this.showPicker = false;
    },
    getleft() {
      this.$http
        .post(this.$api.VAC_GET_QTY, {
          appointDate: this.appointmentdate,
        })
        .then((res) => {
          this.aleft = res[0].aleft;
          this.pleft = res[0].pleft;
        });
    },
    chooiesclick(value) {
      this.chooies = value;
      console.log(this.$route.query);
    },
    appointmentClick() {
      if (!this.username) {
        this.$toast("姓名不能为空");
        return;
      }
      if (!this.$regular.idCard(this.idCard)) {
        this.$toast("请输入正确的身份证号");
        return;
      }
      if (!this.appointmentdate) {
        this.$toast("请选择日期");
        return;
      }
      if (!this.temperature) {
        this.$toast("体温不能为空");
        return;
      }
      if (!this.$regular.phone(this.telphone)) {
        this.$toast("请输入正确手机号");
        return;
      }
      this.$http
        .post(this.$api.VAC_REG, {
          appointDate: this.appointmentdate,
          name: this.username,
          idCard: this.idCard,
          phone: this.telphone,
          timeFrame: this.chooies === "0" ? "A" : "P",
          temp: this.temperature,
          openId: this.openid,
        })
        .then((res) => {
          this.$dialog
            .alert({
              title: "",
              message: "您已预约成功，请按时接种！",
            })
            .then(() => {
              this.$router.push({
                name: "vaccine-record",
                query: {
                  openid: this.openid,
                },
              });
            });
        })
        .catch((error) => {
          this.$dialog
            .alert({
              title: "",
              message: error.message,
            })
            .then(() => {});
        });
    },
    getDate() {
      this.$http.post(this.$api.VAC_GATDATE, {}).then((res) => {
        res.filter((item) => {
          this.dateList.push(item.appointDate);
        });
        // this.appointmentdate = this.dateList[0];
        // this.getleft();
      });
    },
  },
};
</script>
<style lang="less">
.vaccine-form {
  background-color: #f7f8fa;
  &-bg {
    width: 100%;
    height: 17.5rem;
    padding-top: 1.66rem;
    color: white;
    font-weight: 500;
    font-size: 1.31rem;
    text-align: center;
  }
  &-content {
    .van-field__label {
      width: 4.5rem;
    }

    margin: calc(3.03rem - 17.5rem) 1.25rem 0.84rem 1.25rem;
    padding: 0.5rem;
    background-color: white;
    border-radius: 0.63rem;
    &-chooies {
      padding: 0.1rem 0.3rem;
      color: #09f;
      border: 1px #09f solid;
      border-radius: 0.19rem;
    }
    &-unchooies {
      padding: 0.1rem 0.3rem;
      color: #ccc;
      background-color: #f7f8fa;
      border-radius: 0.19rem;
    }
    &-agreement {
      margin: 0 1.25rem 0.84rem 1.25rem;
      padding: 1.25rem;
      color: #fe5546;
      font-size: 0.81rem;
      background-color: white;
      border-radius: 0.63rem;
      span {
        color: #999;
        font-size: 0.71rem;
      }
    }
    &-btn {
      margin: 0.5rem 1.28rem 0 1.28rem;
      color: white;
      line-height: 2.5rem;
      text-align: center;
      background-color: #108eed;
      border-radius: 1.41rem;
    }
  }
}
</style>
